export var ClientContactStatus;
(function (ClientContactStatus) {
    ClientContactStatus["Lead"] = "LEAD";
    ClientContactStatus["Client"] = "CLIENT";
})(ClientContactStatus || (ClientContactStatus = {}));
export var ConnectionChannelDirection;
(function (ConnectionChannelDirection) {
    ConnectionChannelDirection["UnidirectionalNatural"] = "UNIDIRECTIONAL_NATURAL";
    ConnectionChannelDirection["UnidirectionalReverse"] = "UNIDIRECTIONAL_REVERSE";
    ConnectionChannelDirection["Bidirectional"] = "BIDIRECTIONAL";
})(ConnectionChannelDirection || (ConnectionChannelDirection = {}));
export var MediaAttributeType;
(function (MediaAttributeType) {
    MediaAttributeType["Width"] = "WIDTH";
    MediaAttributeType["Height"] = "HEIGHT";
    MediaAttributeType["Duration"] = "DURATION";
})(MediaAttributeType || (MediaAttributeType = {}));
export var OrderTaskListSegmentation;
(function (OrderTaskListSegmentation) {
    OrderTaskListSegmentation["Day"] = "DAY";
    OrderTaskListSegmentation["Category"] = "CATEGORY";
    OrderTaskListSegmentation["DealItem"] = "DEAL_ITEM";
    OrderTaskListSegmentation["Chronological"] = "CHRONOLOGICAL";
})(OrderTaskListSegmentation || (OrderTaskListSegmentation = {}));
export var PdfFormat;
(function (PdfFormat) {
    PdfFormat["Compact"] = "COMPACT";
    PdfFormat["Detailed"] = "DETAILED";
})(PdfFormat || (PdfFormat = {}));
export var PermissionStatus;
(function (PermissionStatus) {
    PermissionStatus["Allow"] = "ALLOW";
    PermissionStatus["Deny"] = "DENY";
})(PermissionStatus || (PermissionStatus = {}));
export var ReportBreakdown;
(function (ReportBreakdown) {
    ReportBreakdown["Channel"] = "CHANNEL";
    ReportBreakdown["Partner"] = "PARTNER";
    ReportBreakdown["User"] = "USER";
    ReportBreakdown["Client"] = "CLIENT";
    ReportBreakdown["Category"] = "CATEGORY";
    ReportBreakdown["Source"] = "SOURCE";
    ReportBreakdown["Campaign"] = "CAMPAIGN";
    ReportBreakdown["PromoCode"] = "PROMO_CODE";
    ReportBreakdown["Day"] = "DAY";
    ReportBreakdown["Week"] = "WEEK";
    ReportBreakdown["Month"] = "MONTH";
    ReportBreakdown["Quarter"] = "QUARTER";
    ReportBreakdown["Year"] = "YEAR";
})(ReportBreakdown || (ReportBreakdown = {}));
export var ReportComparison;
(function (ReportComparison) {
    ReportComparison["PreviousPeriod"] = "PREVIOUS_PERIOD";
    ReportComparison["PreviousYear"] = "PREVIOUS_YEAR";
})(ReportComparison || (ReportComparison = {}));
export var ReportDateBasis;
(function (ReportDateBasis) {
    ReportDateBasis["Default"] = "DEFAULT";
    ReportDateBasis["Event"] = "EVENT";
})(ReportDateBasis || (ReportDateBasis = {}));
export var ReportRowKind;
(function (ReportRowKind) {
    ReportRowKind["Group"] = "GROUP";
    ReportRowKind["OtherFee"] = "OTHER_FEE";
    ReportRowKind["Discount"] = "DISCOUNT";
    ReportRowKind["Tax"] = "TAX";
})(ReportRowKind || (ReportRowKind = {}));
export var VoucherUsedStatus;
(function (VoucherUsedStatus) {
    VoucherUsedStatus["None"] = "NONE";
    VoucherUsedStatus["Partial"] = "PARTIAL";
    VoucherUsedStatus["Complete"] = "COMPLETE";
})(VoucherUsedStatus || (VoucherUsedStatus = {}));
